import { Box } from "@mui/joy";
import { keyframes } from "@mui/system";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

// 색이 무지개를 따라 흐른다
const flow = keyframes`
  to {
    filter: hue-rotate(360deg);
  }
`;

const ringSx = {
  position: "absolute",
  inset: 0,
  borderRadius: "50%",
  background:
    "conic-gradient(from 0deg, rgba(255,94,94,0) 0deg, #FF5E5E 50deg, #FFA53D 110deg, #F5D33B 170deg, #4CC97E 230deg, #3D8BFF 290deg, #9A5CFF 350deg)",
  // 테두리 2.5px 고리만 남긴다
  mask: "radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 2px))",
  WebkitMask:
    "radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 2px))",
} as const;

// 좌측 목록 — 자동으로 채우는 활동지 표시 (상태 동그라미 자리, 20px).
// 무지개 꼬리 고리가 완급을 두고 돌고, 색이 흐른다
export default function RainbowSpinner({ size = 20 }: { size?: number }) {
  return (
    <Box
      role="img"
      aria-label="자동으로 채우는 중"
      sx={{
        position: "relative",
        width: `${size}px`,
        height: `${size}px`,
        flexShrink: 0,
        animation: `${spin} 1.1s cubic-bezier(.55,.15,.45,.85) infinite, ${flow} 3s linear infinite`,
      }}
    >
      <Box sx={ringSx} />
    </Box>
  );
}
